

export function deepClone(a) {
  return JSON.parse(JSON.stringify(a));
}


export function arrayDiffById(a:any[], b:any[]) {
  // Make hashtable of ids in B
  var bIds = {};
  b.forEach((obj) => {
    bIds[obj.id] = obj;
  });

// Return all elements in A, unless in B
  return a.filter((obj) => {
    return !(obj.id in bIds);
  });
}

export const arrayMoveMutate = (array, from, to) => {
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
};

export const arrayMove = (array, from, to) => {
  array = array.slice();
  arrayMoveMutate(array, from, to);
  return array;
};
